import React, { Component } from 'react';
import { Col, Row, Card, CardBody, Container, Button, } from 'reactstrap';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { Field, reduxForm } from 'redux-form';
import moment from 'moment';
import pdfMake from 'pdfmake/build/pdfmake.js';
import MomentUtils from '@date-io/moment';
import { withTranslation } from 'react-i18next';

class ReportEventAdverse extends Component {

    constructor(props) {
        super(props);
        this.state = {
            urlLogo: "",
            profile: [],
            today: new Date(),
        }
    }

    componentDidMount(){
        this.loadDataProfile();
    }

    loadDataProfile = () => {

        fetch(process.env.REACT_APP_PUBLIC_URL + 'clinica/listar', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                console.log(data);
                if (data.length > 0) {
                    this.setState({ profile: data[0], 
                    urlLogo: process.env.REACT_APP_PUBLIC_URL+"clinica/"+ data[0].id_clinica+"/logo/"+sessionStorage.getItem('token') })
                }
            })
            .catch((error) => {
                console.error('Error:', error);
               
            });
    }

    generateReport = async () => {

        pdfMake.fonts = {           
              Roboto: {
                normal: 'Roboto-Regular.ttf',
                bold: 'Roboto-Bold.ttf',
                italics: 'Roboto-Italic.ttf',
                bolditalics: 'Roboto-BoldItalic.ttf'
              }
          };

        const fecha = this.state.today;  
        const user = JSON.parse(sessionStorage.getItem('usuario'));  

        const header = {
            margin: [40, 10, 0, 0],
            layout: 'noBorders',
            table: {
                widths: ['*', '*'],
                body: [
                    [{
                        image: await this.getBase64ImageFromURL(this.state.urlLogo),
                        fit: [100, 40],       
                    },
                    { text: 'CIC-CBIF-REPSEG-346', style: 'head' }],

                ]
            },
        };

        const foter = {
            margin: [20, 0, 0, 0],
            text: 'Usuario y Fecha de Impresión '+ user.usuario + '-' + moment(fecha).format('ll') , style: 'head',
        };

        const documentDefinition = {
            pageSize: 'LETTER',
            pageOrientation: 'portrait',
            header: header,
            footer: foter,
            content: [
                {
                    margin: [0, 20, 0, 0],
                    text: 'Cali, '+ moment(fecha).format('LL'), style: 'paragraf',
                },
                {
                    margin: [0, 15, 0, 0],
                    text: 'Señores ', style: 'paragraf',
                },
                {
                    margin: [0, 0, 0, 0],
                    text: 'Comite de Bioetica en Investigacion Farallones ', style: 'paragraf', bold: true
                },
                {
                    margin: [0, 0, 0, 0],
                    text: 'La ciudad ', style: 'paragraf',
                },  
                {
                    margin: [0, 15, 0, 0],
                    text: 'Asunto:  ', style: 'paragraf',
                },  
                {
                    margin: [0, 15, 0, 0],
                    text: 'Cordial Saludo, ', style: 'paragraf',
                },  
                {
                    margin: [0, 15, 0, 0],
                    text: 'En referencia al estudio clinico \n\n', style: 'paragraf',
                },                                               
                {
                    // auto-sized columns have their widths based on their content                                       
                    margin: [0, 0, 0, 0],
                    table: {
                        widths: ['*', '*', '*','*', '*', '*','*', '*'],
                        body: [
                            [{ text: 'CASE ID ', style: 'textStyle' }, { text: 'FECHA DE REPORTE', style: 'textStyle' }, { text: 'FECHA DE RECEPCION', style: 'textStyle' },
                            { text: 'EVENTO', style: 'textStyle' }, { text: 'INICIAL O SEGUIMIENTO', style: 'textStyle' }, { text: 'PAÍS', style: 'textStyle' },
                            { text: 'Analísis de Investigador Princiapal', style: 'textStyle' },{ text: 'Analísis del Quimico Farmaceutico', style: 'textStyle' },],
                           
                        ]
                    },
                },
                {
                    margin: [0, 15, 0, 0],
                    text: 'Cordialmente,  ', style: 'paragraf',
                },                                                                               
                {
                    // auto-sized columns have their widths based on their content                                       
                    columns: [
                        {                                                                 
                            margin: [25, 50, 25, 0],
                            layout: 'headerLineOnly',
                            table: {
                                widths: [150],
                                headerRows: 1,
                                body: [
                                    [{ text: '' }],
                                    [{ text: 'SUBINVESTIGADOR', style: 'textStyle', }],                                    
                                ]
                            },
                        },
                        {
                            // auto-sized columns have their widths based on their content                                       
                            margin: [25, 50, 25, 0],
                            layout: 'headerLineOnly',
                            table: {
                                widths: [150],
                                headerRows: 1,
                                body: [
                                    [{ text: '' }],
                                    [{ text: 'QUIMICO FARMACEUTICO', style: 'textStyle', }],

                                ]
                            },
                        },
                    ],
                    columnGap: 30
                },
            ],
            styles: {
                head: {
                    fontSize: 7,
                    bold: true,
                    alignment: 'left'
                },
                tableheader: {
                    fontSize: 11,
                    bold: true,

                },
                textStyle: {
                    fontSize: 9,
                },
                paragraf: {
                    fontSize: 10,
                    alignment: 'justify'
                },
                foter: {
                    margin: 10,
                    fontSize: 6,
                },
                medicStyle: {
                    margin: [0, 80, 0, 0],
                    fontSize: 10,
                    alignment: 'left',
                }
            }
        };

        pdfMake.createPdf(documentDefinition).open();
    }


    getBase64ImageFromURL(url) {
        return new Promise((resolve, reject) => {
            var img = new Image();
            img.setAttribute("crossOrigin", "anonymous");

            img.onload = () => {
                var canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;

                var ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0);

                var dataURL = canvas.toDataURL("image/png");

                resolve(dataURL);
            };

            img.onerror = error => {
                reject(error);
            };

            img.src = url;
        });
    }


    render() {

        return (
            <Container >
                <Row>
                    <Col md={12}>
                        <h3 className="page-title">Reporte de Eventos Adversos</h3>
                    </Col>
                </Row>
                <Card >
                    <CardBody >
                        <Col >
                            <div style={{ display: 'flex', flexDirection: 'column', }}>
                                <form className="material-form" >
                                    <TextField
                                        className="material-form__field"
                                        label="Estudio Clinico"
                                        id="studio-select"
                                        style={{ width: 200, margin: 30 }}
                                        select
                                        defaultValue={null}
                                        onChange={(event) => {
                                            console.log(event);

                                        }}
                                    >
                                        <MenuItem className="material-form__option" key={1} value={'todos'}>Todos</MenuItem>
                                    </TextField>

                                    <TextField
                                        className="material-form__field"
                                        label="Investigador"
                                        id="reserch-select"
                                        style={{ width: 200, margin: 30 }}
                                        select
                                        defaultValue={null}
                                        onChange={(event) => {
                                            console.log(event);

                                        }}
                                    >
                                        <MenuItem className="material-form__option" key={1} value={'todos'}>Todos</MenuItem>
                                    </TextField>
                                    
                                        <MuiPickersUtilsProvider utils={MomentUtils} >
                                            <KeyboardDatePicker
                                                label="Fecha Inicial"
                                                className="material-form__field"
                                                onChange={(date) => {

                                                }}
                                                format="yyyy/MM/DD"
                                                animateYearScrolling
                                                style={{ width: 200, margin: 30 }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}

                                            />
                                        </MuiPickersUtilsProvider>

                                        <MuiPickersUtilsProvider utils={MomentUtils} >
                                            <KeyboardDatePicker
                                                label="Fecha Final"
                                                className="material-form__field"
                                                onChange={(date) => {

                                                }}
                                                format="yyyy/MM/DD"
                                                animateYearScrolling
                                                style={{ width: 200, margin: 30 }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}

                                            />
                                        </MuiPickersUtilsProvider>                                    

                                    <TextField
                                        className="material-form__field"
                                        label="Clasificación Evento"
                                        id="clasificacion-select"
                                        style={{ width: 200, margin: 30 }}
                                        select
                                        onChange={(event) => {
                                            console.log(event);

                                        }}
                                    >
                                        <MenuItem className="material-form__option" key={1} value={'CIOMS'}>CIOMS</MenuItem>
                                    </TextField>

                                    <div style={{ display:'flex', justifyContent:'flex-end'}}>
                                        <Button
                                            color="primary"
                                            style={{ margin: 30 }}
                                            onClick={() => {
                                                //this.setState({ openModal: true });
                                                this.generateReport();
                                            }}
                                        >
                                            Generar
                                        </Button>
                                    </div>
                                </form>
                            </div>
                        </Col>
                    </CardBody>
                </Card>
            </Container>
        );
    }
}

export default reduxForm({
    form: `report-event-adverse-form`, // a unique identifier for this form
})(withTranslation('common')(ReportEventAdverse));
